var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48,83.2011658 C46.5050054,83.2011658 44.6236638,81.8078091 43.4709222,81.0297821 C40.7853911,79.2192528 38.17335,77.2960868 35.6389981,75.2832287 C22.8517548,65.1250743 10.1967933,51.6608265 8.58001541,34.7382174 C7.71283454,25.6563685 13.9951715,16.8185656 22.5262995,13.9087863 C32.2668614,10.586006 43.3596375,14.9371169 48,24.1065721 C52.6403625,14.9371169 63.7331386,10.586006 73.4737005,13.9087863 C82.0048285,16.8185656 88.2871655,25.6563685 87.4199846,34.7382174 C85.8032067,51.6608265 73.1482452,65.1250743 60.3610019,75.2832287 C57.82665,77.2960868 55.2146089,79.2192528 52.5290778,81.0297821 C51.3763362,81.8078091 49.4949946,83.2011658 48,83.2011658 Z",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgHeartFilled;